import Plugin from 'lib/modulor/plugin'

export default class Loader extends Plugin
  @defaults =
    debug: false
    name: 'Modulor::Lock::FormObject__Loader'

  @selector: ".modulor_lock_form_object"

  on_init: ->
    `import('./lock_form_object' /* webpackChunkName: "modulor_lock_form_object" */)`

Loader.register()
